import { useEffect, useState } from 'react'

import { EVENT_NAME_SCROLL } from '../../../../constants/event'
import { useThrottleFunc } from '../../../../hooks'
import { calculateElementCenterY } from '../../../../utils/common'

export function usePdfViewerNavigation({
  containerRef,
  isPdfFinishedRendering,
  pageNumber,
  pdfPageRef,
  viewerRootElement,
}) {
  const [arrowNavigationY, setArrowNavigationY] = useState(0)

  function calculateCenterY() {
    const pdfPage = pdfPageRef.current

    if (pdfPage && viewerRootElement) {
      const pageOffsetTop =
        pdfPage.getBoundingClientRect().top -
        viewerRootElement.getBoundingClientRect().top

      calculateElementCenterY({
        container: containerRef.current,
        scrollElement: pdfPage,
        onChangeY: pageCenterY => {
          setArrowNavigationY(pageCenterY + pageOffsetTop)
        },
      })
    }
  }

  const { throttledHandler: handleCalculateButtonY } = useThrottleFunc(
    calculateCenterY,
    300
  )

  // the page div appears after mount and is swapped per page in page scroll
  // mode, so `useResizeObserver` (observes once) cannot be used here
  useEffect(() => {
    const pdfPage = pdfPageRef.current

    if (pdfPage) {
      calculateCenterY()

      const observer = new ResizeObserver(handleCalculateButtonY)

      observer.observe(pdfPage)

      return () => {
        observer.disconnect()
      }
    }
  }, [isPdfFinishedRendering, pageNumber])

  useEffect(() => {
    if (containerRef.current && pdfPageRef.current) {
      const elem = containerRef.current

      elem.addEventListener(EVENT_NAME_SCROLL, handleCalculateButtonY)

      return function cleanup() {
        elem.removeEventListener(EVENT_NAME_SCROLL, handleCalculateButtonY)
      }
    }
  }, [handleCalculateButtonY, isPdfFinishedRendering])

  return {
    arrowNavigationY,
  }
}
